// extracted by mini-css-extract-plugin
export var active = "_8y-a";
export var activeIndicator = "_8y-9";
export var disabled = "_8y-b";
export var fullWidth = "_8y-2";
export var lg = "_8y-7";
export var md = "_8y-6";
export var redoButtonTabGroup = "_8y-0";
export var sm = "_8y-5";
export var tabButton = "_8y-4";
export var tabButtonsContainer = "_8y-1";
export var themeDestructive = "_8y-d";
export var themeNormal = "_8y-c";
export var themeSuccess = "_8y-e";
export var xl = "_8y-8";
export var xs = "_8y-3";